/** @format */

import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import styled from 'styled-components'
import { Card } from '@king-design/react'
import GraphX6 from 'src/pages/EventOps/Scene/Detail/SceneGraph/Graph'
import { Cell, Node, Edge } from '@antv/x6'
import { GraphX6Ref } from 'src/components/GraphX6/types'
import NodeDrawer from './NodeDrawer'
import { ProcessRecordVariableProps, getNodeVariable } from '../container'

interface FlowProcessProps {
  className?: string
  nodes: Node.Properties[]
  edges: Edge.Properties[]
  variables: ProcessRecordVariableProps[]
}

const FlowProcess: React.FC<FlowProcessProps> = ({ className, nodes, edges, variables }) => {
  // 画布ref
  const graphRef = useRef<GraphX6Ref>(null)
  // 节点抽屉
  const [nodeDrawerVisible, setNodeDrawerVisible] = useState(false)
  const [nodeDrawerData, setNodeDrawerData] = useState<Cell.Properties>()

  // 节点执行时入参出参
  const nodeVariable = useMemo(() => {
    if (nodeDrawerData?.data?.processID && variables?.length) {
      return getNodeVariable(nodeDrawerData?.data?.processID, variables)
    } else {
      return {
        inputs: {},
        outputs: {}
      }
    }
  }, [nodeDrawerData?.data?.processID, variables])

  // 计算画布高度
  const graphHeight = (): number => {
    // 所有接在在y轴产生的最大值
    const max = Math.max(...nodes?.map(item => item.position?.y), 0)
    // 所有接在在y轴产生的最小值
    const min = Math.min(...nodes?.map(item => item.position?.y), 0)

    return Math.abs(max - min) + 150
  }

  // 图形初始化完成回调
  const handleGraphReady = useCallback(
    graph => {
      // 可以在这里执行需要 graph 实例的操作
      graph.on('cell:click', event => {
        const cell = event.cell
        if (
          ['AUTOTASK_DISPLAY', 'GATEWAY', 'END', 'AUTOTASK_SUBSCENE', 'USERTASK'].includes(
            cell?.data?.type
          ) &&
          cell.data
        ) {
          setNodeDrawerVisible(true)
          setNodeDrawerData(cell)
        }
      })
      graph?.fromJSON({
        nodes: nodes || [],
        edges: edges || []
      })
      graph?.centerContent()
    },
    [nodes, edges]
  )

  useEffect(() => {
    if (graphRef?.current?.graph) {
      graphRef.current.graph.fromJSON({
        nodes: nodes || [],
        edges: edges || []
      })
      graphRef.current.graph?.centerContent()
    }
  }, [nodes, edges])

  return (
    <Card className={className} title="执行记录" type="border" style={{ marginBottom: 16 }}>
      <div style={{ height: graphHeight() }}>
        <GraphX6 ref={graphRef} onGraphReady={handleGraphReady} />
      </div>
      <NodeDrawer
        visible={nodeDrawerVisible}
        onClose={() => {
          setNodeDrawerVisible(false)
          setNodeDrawerData(undefined)
        }}
        node={nodeDrawerData}
        nodeVariable={nodeVariable}
      />
    </Card>
  )
}

export default styled(FlowProcess)``
